import React from 'react';
import c from 'classnames';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

import './style.scss';

const Audio = ({ url, className }) => {
  const classNames = c('Audio', className);

  return (
    <div className={classNames}>
      <ReactPlayer
        className="Audio__inner"
        url={url}
        width="100%"
        controls
      />
    </div>
  );
};

Audio.defaultProps = {
  className: '',
};

Audio.propTypes = {
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Audio;
